import styled from "styled-components";

export const RoomRentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const RoomRentContainerHeader = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  gap: 1rem;
  & > * {
    flex-basis: calc(80% / 2);
  }
  & > :first-child {
    flex-basis: calc(20%);
  }
`;
